import React, { useState } from 'react';

import { t } from 'i18next';

import BdsRadioButton from '../../../../../../../shared/components/v3/BdsRadioButton/BdsRadioButton';
import BdsTooltip from '../../../../../../../shared/components/v3/BdsTooltip/BdsTooltip';
import BdsCardContainer from '../../../../../../../shared/components/v3/Cards/BdsCardContainer/BdsCardContainer';
import { LOCALE_COUNTRYS } from '../../../../../../../shared/constants/manageCollaborators';
import { ISelectPlanCard } from '../../../../../../../shared/interfaces/cards';
import { TRANSLATION_MANAGE_COLLABORATORS } from '../../../../../../../shared/translations/manageCollaborators';
import Addons from '../../../PlanAddons/PlanAddons';
import './SelectPlanCard.scss';

const SelectPlanCard = ({ onChange, plan, selected }: ISelectPlanCard) => {
  const [showTooltip, setShowTooltip] = useState<boolean>(false);
  const separator = ' • ';

  const getCountryName = (countryCode: string) => {
    if (!countryCode) return TRANSLATION_MANAGE_COLLABORATORS.country.international;
    const key = TRANSLATION_MANAGE_COLLABORATORS.country.key;
    const countryName = LOCALE_COUNTRYS[countryCode].country.toLowerCase();

    return `${key}${countryName}`;
  };

  const handleOnChange = (planId: string): void => {
    onChange(planId);
  };

  const handleShowTooltip = (show: boolean) => {
    if ((plan.name.length >= 13 && plan.addons.length >= 1) || plan.name.length >= 27) {
      setShowTooltip(show);
    }
  };

  return (
    <BdsCardContainer
      className="select-plan-card flex flex-col justify-start"
      paddingSize="padding-l"
      borderRadiusSize="radius-m"
      onClick={() => handleOnChange(plan.id.toString())}
    >
      <div className="radio-button flex flex-row align-center justify-end w-full">
        <BdsRadioButton
          name={`plan-${plan.name}`}
          value={plan.id.toString()}
          selected={selected}
          onChange={handleOnChange}
        />
      </div>
      <div className="info flex flex-col w-full">
        <div className="top flex flex-row align-center justify-start text-start w-full">
          <BdsTooltip open={showTooltip} message={plan.name} showPointer={true} position="top-left">
            <></>
          </BdsTooltip>
          <button
            onMouseEnter={() => handleShowTooltip(true)}
            onMouseLeave={() => handleShowTooltip(false)}
            className="name"
          >
            {plan.name}
          </button>
          <Addons planAddons={plan.addons} />
        </div>
        <div className="bottom flex flex-row align-center justify-start w-full">
          <span className="country">{t(getCountryName(plan.countryCode))}</span>
          <span className="price">{`${separator}${plan.price} ${plan.currency}`}</span>
        </div>
      </div>
    </BdsCardContainer>
  );
};

export default SelectPlanCard;
